import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
    webhookRequest: ["businessId"],
    createWebhookRequest: ["businessId", "url", "interests", "authHeaderName", "authHeaderValue"],
    updateWebhookRequest: ["webhookId", "businessId", "url", "interests", "authHeaderName", "authHeaderValue"],
    toggleWebhookRequest: ["webhookId"],

    webhookSuccess: ["webhook"],
    createWebhookSuccess: ["webhook"],
    updateWebhookSuccess: ["webhook"],
    toggleWebhookSuccess: ["webhook"],

    webhookFailure: ["error"],
    createWebhookFailure: ["error"],
    updateWebhookFailure: ["error"],
    toggleWebhookFailure: ["error"],
});

export const WebhookTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
    fetchingWebhook: null,
    webhook: null,
    creating: null,
    updating: null,
    toggling: null,
    errorFetching: null,
    errorCreating: null,
    errorUpdating: null,
    errorToggling: null,
});

export const request = (state) => {
    return { ...state, fetchingWebhook: true, errorFetching: null };
};

export const createWebhookRequest = (state) => {
    return { ...state, creating: true, errorCreating: null };
};

export const updateWebhookRequest = (state) => {
    return { ...state, updating: true, errorUpdating: null };
};

export const toggleWebhookRequest = (state) => {
    return { ...state, toggling: true, errorToggling: null };
};

export const success = (state, action) => {
    const { webhook } = action;
    return { ...state, fetchingWebhook: false, webhook };
};

export const createWebhookSuccess = (state, action) => {
    const { webhook } = action;
    return { ...state, creating: false, errorCreating: null, webhook };
};

export const updateWebhookSuccess = (state, action) => {
    const { webhook } = action;
    return { ...state, updating: false, errorUpdating: null, webhook };
};

export const toggleWebhookSuccess = (state, action) => {
    const { webhook } = action;
    return { ...state, toggling: false, errorToggling: null, webhook };
};

export const failure = (state, action) => {
    const { error } = action;
    return { ...state, errorFetching: error, fetchingWebhook: false, webhook: null };
};

export const createWebhookFailure = (state, action) => {
    const { error } = action;
    return { ...state, errorCreating: error, creating: false };
};

export const updateWebhookFailure = (state, action) => {
    const { error } = action;
    return { ...state, errorUpdating: error, updating: false };
};

export const toggleWebhookFailure = (state, action) => {
    const { error } = action;
    return { ...state, errorToggling: error, toggling: false };
};

export const reducer = createReducer(INITIAL_STATE, {
    [Types.WEBHOOK_REQUEST]: request,
    [Types.CREATE_WEBHOOK_REQUEST]: createWebhookRequest,
    [Types.UPDATE_WEBHOOK_REQUEST]: updateWebhookRequest,
    [Types.TOGGLE_WEBHOOK_REQUEST]: toggleWebhookRequest,

    [Types.WEBHOOK_SUCCESS]: success,
    [Types.CREATE_WEBHOOK_SUCCESS]: createWebhookSuccess,
    [Types.UPDATE_WEBHOOK_SUCCESS]: updateWebhookSuccess,
    [Types.TOGGLE_WEBHOOK_SUCCESS]: toggleWebhookSuccess,

    [Types.WEBHOOK_FAILURE]: failure,
    [Types.CREATE_WEBHOOK_FAILURE]: createWebhookFailure,
    [Types.UPDATE_WEBHOOK_FAILURE]: updateWebhookFailure,
    [Types.TOGGLE_WEBHOOK_FAILURE]: toggleWebhookFailure,
});
